export const createYoutubeLink = (link: string) => {
    return link.replace('watch?v=', 'embed/').replace('youtu.be/', 'www.youtube.com/embed/');
};

export const createYoutubeEmbedPreviewSrc = (link: string) => {
    return link.replace('www.youtube.com/embed/', 'i.ytimg.com/vi/').concat('/hqdefault.jpg');
};
